import React from "react";
import type { MerchantRedemptionsTrendResponse } from "../types/merchant-home-data.types";
import { getTrendChartPoints } from "../utils/merchantHomeViewModels";
import { MerchantHomeErrorState } from "./MerchantHomeErrorState";
import { RedemptionsChart } from "./RedemptionsChart";

interface MerchantHomeTrendSectionProps {
  trend: MerchantRedemptionsTrendResponse | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}

export const MerchantHomeTrendSection: React.FC<MerchantHomeTrendSectionProps> = ({
  trend,
  loading,
  error,
  onRetry,
}) => {
  if (loading && !trend) {
    return (
      <div className="h-80 animate-pulse rounded-2xl bg-white outline outline-1 outline-offset-[-1px] outline-gray-200 dark:bg-gray-800 dark:outline-gray-700" />
    );
  }

  if (error && !trend) {
    return (
      <MerchantHomeErrorState
        message={error}
        onRetry={onRetry}
      />
    );
  }

  if (!trend) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {error ? (
        <div className="flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700 dark:border-red-700 dark:bg-red-900/20 dark:text-red-300">
          <span>{error}</span>
          <button
            type="button"
            onClick={onRetry}
            className="font-semibold hover:opacity-80"
          >
            Retry
          </button>
        </div>
      ) : null}
      <RedemptionsChart
        data={getTrendChartPoints(trend)}
        currentRedemptions={trend.this_week}
        growth={trend.growth_percent}
        thisWeek={trend.this_week}
        lastWeek={trend.last_week}
        avgWeek={trend.avg_per_week}
      />
    </div>
  );
};
